import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 21"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.088 9.354a3.25 3.25 0 0 0 0 2.434c.188.466.565.92 1.569 2.091.557.65.772.896 1.012 1.084.4.313.868.528 1.366.628.299.06.625.063 1.481.063H12.5c.863 0 1.476 0 1.96-.03.476-.03.776-.087 1.018-.178a3.25 3.25 0 0 0 1.897-1.897c.09-.242.148-.542.178-1.019.03-.483.03-1.096.03-1.96 0-.862 0-1.475-.03-1.958-.03-.477-.087-.778-.178-1.02a3.25 3.25 0 0 0-1.897-1.896c-.242-.091-.542-.148-1.019-.178-.483-.03-1.096-.03-1.96-.03H8.517c-.856 0-1.182.003-1.481.063a3.25 3.25 0 0 0-1.366.628c-.24.188-.455.433-1.012 1.084-1.004 1.17-1.38 1.625-1.569 2.09Zm-1.39 2.996a4.75 4.75 0 0 1 0-3.558c.291-.723.85-1.374 1.722-2.392l.098-.113.051-.06c.489-.57.803-.938 1.174-1.228a4.75 4.75 0 0 1 1.998-.919c.462-.093.945-.093 1.696-.092h4.088c.832 0 1.492 0 2.028.033.547.034 1.014.106 1.453.271a4.75 4.75 0 0 1 2.773 2.772c.165.44.236.907.27 1.454.034.536.034 1.195.034 2.028v.05c0 .832 0 1.492-.033 2.028-.035.547-.106 1.014-.271 1.454a4.75 4.75 0 0 1-2.773 2.772c-.44.165-.906.236-1.453.27-.536.034-1.196.034-2.028.034H8.436c-.75 0-1.233 0-1.695-.092a4.749 4.749 0 0 1-1.997-.919c-.372-.29-.686-.658-1.175-1.227a29.43 29.43 0 0 1-.051-.06l-.098-.114c-.872-1.018-1.43-1.669-1.723-2.392Zm5.719-1.78a.917.917 0 1 0 1.833.001.917.917 0 0 0-1.833 0Zm.916 2.418a2.417 2.417 0 1 1 0-4.834 2.417 2.417 0 0 1 0 4.834Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
